module.exports = __webpack_public_path__ + "img/CameraHeadPCB.4a6c9fd1.png";